import { useLiveChatStore } from './composables'

export default defineNuxtPlugin(() => {
  const liveChat = useLiveChatStore()
  
  // Make live chat available globally
  return {
    provide: {
      liveChat
    }
  }
})
